import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CountryShared } from '../../../models/interface/country.interface';
import { CreditCardFranchise } from '../../../models/interface/creditCardFranchise.enum';
import { ItemNumberToFilterShared } from '../../../models/interface/itemNumberToFilter.interface';
import { MuFieldPositionEnum } from '../../../models/interface/muFieldPosition.enum';
import { PaymentAddCardField } from '../../../models/interface/paymentAddCardField.interface';
import { FormControlValidatorService } from '../../../sharedServices/form-control-validator.service';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';
import { MuComponent } from '../../../types/MuComponent.componetent';

@Component({
  selector: 'app-mu-payment-add-card',
  templateUrl: './mu-payment-add-card.component.html',
  styleUrls: ['./mu-payment-add-card.component.sass'],
})
export class MuPaymentAddCardComponent<ActionType, FlagType> extends MuComponent implements OnChanges {
  @Input() customClass = 'default-express-add-card-sizes';
  @Input() actionList: Actions<ActionType, any>;
  @Input() flagList: Flags<FlagType>;
  @Input() formData: UntypedFormGroup;
  @Input() documentTypeList: ItemNumberToFilterShared[];
  @Input() franchise: string;
  @Input() showFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() saveAction: ActionType;
  @Input() fieldList: PaymentAddCardField;
  @Input() country: CountryShared;
  @Input() getTypeCardAction: ActionType;
  fieldPosition = MuFieldPositionEnum;
  creditCardFranchiseEnum = CreditCardFranchise;
  watched: boolean;

  constructor(private changeDetector: ChangeDetectorRef, private elementRef: ElementRef, private validator: FormControlValidatorService) {
    super();
    this.fieldList = {
      expiration: 'expiration',
      documentNumber: 'documentNumberCard',
      cardNumber: 'cardNumber',
    };
    changeDetector.detach();
  }

  muOnDestroy() {
    document.body.removeChild(this.elementRef.nativeElement);
  }

  muOnInit(): void {
    setTimeout(() => this.changeDetector.reattach());
    document.body.appendChild(this.elementRef.nativeElement);
  }

  /**
   * Event emmit action save credit card
   */
  save(): void {
    this.actionList?.emit(this.saveAction, null);
  }

  ngOnChanges(): void {
    if (!this.formData || this.watched) {
      return environment.guardClause;
    }
    const expirationControl = this.formData.get(this.fieldList.expiration);
    const documentNumberControl = this.formData.get(this.fieldList.documentNumber);
    const cardNumberControl = this.formData.get(this.fieldList.cardNumber);
    this.watched = true;

    this.watch(expirationControl.valueChanges.pipe(debounceTime(250), distinctUntilChanged())).subscribe(value => {
      this.checkExpiration(value);
    });

    this.watch(documentNumberControl.valueChanges.pipe(debounceTime(250), distinctUntilChanged())).subscribe(value => {
      if (this.country.geoName !== 'CO') {
        documentNumberControl.setValidators([Validators.required, this.validator.isAlphanumeric()]);
      }
      documentNumberControl.updateValueAndValidity();
    });

    this.watch(cardNumberControl.valueChanges.pipe(debounceTime(0), distinctUntilChanged())).subscribe(value => {
      if (value) {
        this.actionList.emit(this.getTypeCardAction, value);
      }
    });
  }

  checkExpiration(value?: any): void {
    const expirationControl = this.formData.get(this.fieldList.expiration);
    value = value || this.formData.get(this.fieldList.expiration).value;
    if (!value) {
      expirationControl.updateValueAndValidity();
      expirationControl.setErrors({ invalid: true });
      return environment.guardClause;
    }
    const currentDate = new Date();
    const actualYear = currentDate.getFullYear().toString().slice(2,4);
    const actualMotnh = currentDate.getMonth();
    const dateValue = value?.split('/');

    if (value !== null && ((actualYear === dateValue[1] && dateValue[0] <= actualMotnh) || dateValue[1] < actualYear)) {
      setTimeout(() => {
        expirationControl.updateValueAndValidity();
        expirationControl.setErrors({ invalid: true });
      }, 100);
    }

    if (value !== null && parseInt(dateValue[0] + '', 10) > 12 && dateValue[1].length === 2) {
      const reFormat = 0 + dateValue[0].substr(0, 1) + '/' + dateValue[0].substr(1, 1) + dateValue[1].substr(0, 1);
      expirationControl.patchValue(reFormat);
      expirationControl.setErrors({ invalid: false });
      expirationControl.updateValueAndValidity();
    }
  }
}
